import { required, TextInput, useNotify } from "react-admin";
// MUI Button (not react-admin's) - same as the neighbouring EditEmailDialog / PasswordResetAction,
// so the buttons in the student's personal data have one height and the icon also shows on mobile.
import { Button } from "@mui/material";
import FormModal from "server/components/Modals/FormModal";
import Edit from "@mui/icons-material/Edit";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";

const IbanModal = ({ record, iban, fetchIban }) => {
  const notify = useNotify();

  const handleSubmit = async formData => {
    await dataProvider.customRequest(
      studentRequests.getStudentIban(record?.studentId),
      { ibanNumber: formData?.ibanNumber },
      "PATCH",
    );
    fetchIban();
    notify("Успешна редакция на IBAN", { type: "success" });
  };

  return (
    <FormModal
      titleContent="Редакция на IBAN"
      onConfirm={handleSubmit}
      defaultValues={iban}
      triggerButton={
        <Button
          variant="contained"
          size="small"
          startIcon={<Edit />}
        >
          Редакция на IBAN
        </Button>
      }
    >
      <TextInput
        label="IBAN"
        source="ibanNumber"
        validate={required()}
        fullWidth
      />
    </FormModal>
  );
};

export default IbanModal;
